// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* eslint:disable */
export const VERSION = {
    "dirty": true,
    "raw": "v1.3.2-beta-2-g793702b-dirty",
    "hash": "g793702b",
    "distance": 2,
    "tag": "v1.3.2-beta",
    "semver": {
        "options": {
            "loose": false,
            "includePrerelease": false
        },
        "loose": false,
        "raw": "v1.3.2-beta",
        "major": 1,
        "minor": 3,
        "patch": 2,
        "prerelease": [
            "beta"
        ],
        "build": [],
        "version": "1.3.2-beta"
    },
    "suffix": "2-g793702b-dirty",
    "semverString": "1.3.2-beta+2.g793702b",
    "version": "1.3.2",
    "buildDate": "March 17th 2026, 4:42:40 pm"
};
/* eslint:enable */
